<style src="./DistributorEditor.scss" lang="scss" scoped></style>
<template>
  <section class="distributors">
    <content-header path="Cadastro / Distribuidores"/>

    <section class="row">
      <div class="col-5">
        <form
          @submit.prevent="updateRegister"
          class="form-box row">

          <textbox
            class="col-12"
            label="Nome da distribuidora"
            v-model="form.name" />
          <textbox
            class="col-12"
            label="CNPJ"
            v-model="form.cnpj" />
          
          <div class="textfield col-12">
            <label class="checkbox-label">
              <span class="label">Contabilizar nos resultados</span>

              <input
                class="checkbox-input"
                type="checkbox"
                v-model="form.isDefault">
            </label>
          </div>

          <div class="commands col-12">
            <button-submit
              class="submit"
              label="Atualizar Informações"
              :icon-save="commands.saveIcon"/>
          </div>
        </form>

        <form
          @submit.prevent="changeDistributor"
          class="form-box row">
          <h2>Substituir Distribuidora</h2>
          <p>Para substituir a empresa atual por outra empresa, informe o CNPJ da empresa que irá substituir no campo abaixo</p>

          <textbox
            class="col-12"
            label="CNPJ da distribuidora"
            v-model="changeDistributorForm.cnpj" />
          <div class="commands col-12">
            <button-submit
              class="submit col-6"
              label="Substituir"
              :icon-save="commands.saveIcon"/>
          </div>
        </form>
      </div>


      <section class="form-box col-7 resulthistory">
        <h2>Histórico de Resultados</h2>
        <ul class="list">
          <li
            class="item"
            v-for="(history, historyIdx) in historyList"
            :key="historyIdx"
            @click="openEvent(history._id)">
            <span class="date">
              {{ history.date.event | DateTimeBR }}
            </span>
            <span class="identification" :title="history.alternativeCode">
              {{ history.identification }}
            </span>
            <span class="client">
              {{ history.client.name}}
            </span>
            <span class="result">
              <small>R$&nbsp;</small><strong>{{ history.result.distributors[0].total | CurrencyBR }}</strong>
            </span>
          </li>
        </ul>
      </section>
    </section>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import { Textbox, ButtonSubmit, SuggestDistribuitor } from '@/components/primitives'
import { IconSave } from '@/components/primitives/icons'
import { CurrencyBR } from '@/components/primitives/helpers/filters'

import { ReadDistributor, UpdateDistributor, ChangeDistributor } from '@/brain/record/distributor'

import moment from 'moment'

export default {
  name: 'DistributorEditor',
  components: {
    ContentHeader,
    Textbox,
    IconSave,
    ButtonSubmit,
    SuggestDistribuitor
  },
  data () {
    return {
      form: {
        id: '',
        name: '',
        cnpj: '',
        isDefault: ''
      },
      changeDistributorForm: {
        cnpj: ''
      },
      historyList: [],
      commands: {
        submitState: 'REPOSE',
        saveIcon: IconSave
      }
    }
  },
  filters: {
    CurrencyBR,
    DateTimeBR: (dt) => moment(dt).format('DD/MM/YYYY HH:mm')
  },
  mounted () {
    this.readRegister()
  },
  methods: {
    async readRegister () {
      const registerId = this.$route.params && this.$route.params.id
      const { register, eventsParticipated } = await ReadDistributor({ id: registerId })
      this.form.name = register.name
      this.form.cnpj = register.details.cnpj
      this.form.isDefault = register.isDefault
      this.form.id = register._id
      this.historyList = eventsParticipated.register
    },
    async updateRegister () {
      try {
        await UpdateDistributor(this.form)
        this.$toasted.success('Registro salvo com sucesso')
      } catch (error) {
        this.$toasted.error('Não foi possível atualizar')
      }
    },
    openEvent (eventId) {
      const routeData = this.$router.resolve({ name: 'EventDetail', params: { id: eventId } })
      window.open(routeData.href, '_blank')
    },
    async changeDistributor () {
      try {
        const changeForm = {
          originId: this.form.id,
          destinyCnpj: this.changeDistributorForm.cnpj
        }
        await ChangeDistributor(changeForm)
        this.$toasted.success('Registro salvo com sucesso')
      } catch (error) {
        this.$toasted.error('Não foi possível atualizar')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/distributor/components/edit/DistributorEditor.vue